export default "__VITE_ASSET__DHe1kP1Z__"